import { render, staticRenderFns } from "./PerformanaceOption.vue?vue&type=template&id=09a88a8f"
import script from "./PerformanaceOption.vue?vue&type=script&lang=js"
export * from "./PerformanaceOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports